"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9938],{

/***/ 1399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ InputAutosuggestBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_autosuggest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58808);
/* harmony import */ var react_autosuggest__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_autosuggest__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_Label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35183);
/* harmony import */ var main_javascripts_components_form_InputError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44464);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_constants_DestinationTypes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25551);
/* harmony import */ var main_javascripts_components_atoms_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74303);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58589);
/* harmony import */ var _icon_SvgIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50169);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35944);


var _excluded = ["onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


















var InputAutosuggestBlock = function InputAutosuggestBlock(props) {
  var _props$namespace = props.namespace,
      namespace = _props$namespace === void 0 ? "common" : _props$namespace,
      label = props.label,
      input = props.input,
      fetchDestinationSuggest = props.fetchDestinationSuggest,
      suggestions = props.suggestions,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onSelected = props.onSelected,
      suggestOptions = props.suggestOptions,
      onClear = props.onClear,
      error = props.error,
      inputBlockRef = props.inputBlockRef,
      preventClearWhenInputBoxIsBlank = props.preventClearWhenInputBoxIsBlank,
      forceDisplayCloseButton = props.forceDisplayCloseButton,
      _props$disableOnFocus = props.disableOnFocusRequest,
      disableOnFocusRequest = _props$disableOnFocus === void 0 ? false : _props$disableOnFocus,
      _props$alwaysShowSugg = props.alwaysShowSuggestions,
      alwaysShowSuggestions = _props$alwaysShowSugg === void 0 ? false : _props$alwaysShowSugg,
      _props$borderColorSty = props.borderColorStyleKey,
      borderColorStyleKey = _props$borderColorSty === void 0 ? "none" : _props$borderColorSty,
      _props$fontSizeStyleK = props.fontSizeStyleKey,
      fontSizeStyleKey = _props$fontSizeStyleK === void 0 ? "default" : _props$fontSizeStyleK,
      suggestIconType = props.suggestIconType;
  var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useFormContext */ .Gc)(),
      register = _useFormContext.register;

  var _register = register(input.name),
      onChange = _register.onChange,
      registerProps = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_register, _excluded);

  var onChangeDestination = function onChangeDestination(event, params) {
    var value = event.target.value;

    if (input.onChange) {
      input.onChange(event);
    }

    onSuggestionsFetchRequested({
      value: value,
      reason: "input-changed"
    });

    if (!preventClearWhenInputBoxIsBlank && params && params.newValue === "" && onClear) {
      onClear();
    }
  };

  var onSuggestionSelected = function onSuggestionSelected(_, data) {
    if (input.onChange) {
      input.onChange(data.suggestion.longName);
    }

    onSelected(data.suggestion);
  };

  var getSuggestionValue = function getSuggestionValue(suggestion) {
    return suggestion.name;
  };

  var renderSuggestion = function renderSuggestion(suggestion, _) {
    var iconType = "pin";
    var svgIconType;
    var isSvgIcon = false;
    var svgIconTypes = ["cruise"];

    if (suggestIconType) {
      if (svgIconTypes.includes(suggestIconType)) {
        svgIconType = suggestIconType;
        isSvgIcon = true;
      } else {
        iconType = suggestIconType;
      }
    } else {
      switch (suggestion.destinationType) {
        case main_javascripts_constants_DestinationTypes__WEBPACK_IMPORTED_MODULE_5__/* .DestinationTypes.region */ ._.region:
          iconType = "city";
          break;

        case main_javascripts_constants_DestinationTypes__WEBPACK_IMPORTED_MODULE_5__/* .DestinationTypes.hotel */ ._.hotel:
          iconType = "hotel";
          break;

        case main_javascripts_constants_DestinationTypes__WEBPACK_IMPORTED_MODULE_5__/* .DestinationTypes.airport */ ._.airport:
          iconType = "airplane";
          break;

        default:
      }
    }

    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)("div", {
      css: suggestStyle,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("div", {
        css: iconStyle,
        children: isSvgIcon ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_11__/* .SvgIcon */ .l, {
          name: svgIconType
        }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(main_javascripts_components_atoms_Icon__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .J, {
          styleKey: iconType
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)("div", {
        css: suggestionValueBlockStyle,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("div", {
          css: suggestionValueStyle,
          children: suggestion.name
        }), suggestion.label && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("div", {
          css: suggestionLabelStyle,
          children: suggestion.label
        })]
      })]
    });
  };

  var onSuggestionsFetchRequested = function onSuggestionsFetchRequested(request) {
    if (!request.value) {
      return;
    }

    if (request.reason !== "input-changed" && (disableOnFocusRequest || request.reason !== "input-focused")) {
      return;
    }

    fetchDestinationSuggest(_objectSpread({
      text: request.value
    }, suggestOptions || {}));
  };

  var onSuggestionsClearRequested = function onSuggestionsClearRequested() {
    console.log("clear");
  };

  var onClearInput = function onClearInput(event) {
    event.preventDefault();

    if (inputRef.current) {
      inputRef.current.value = "";
    }

    if (onClear) {
      onClear();
    }
  }; // react hook formのonChangeと合成


  var onInputChange = function onInputChange(e) {
    void onChange(e);
    onChangeDestination(e);
  };

  var renderInputComponent = function renderInputComponent(inputProps) {
    // デフォルトではreact-autosuggestとreact hook formの両方でrefを登録する必要があるため
    // react-autosuggestのfocusInputOnSuggestionClickをfalseにして
    // refを不要にする
    // もしfocusInputOnSuggestionClickが必要な場合はrefを合成する
    // https://github.com/moroshko/react-autosuggest/issues/646
    // https://github.com/facebook/react/issues/13029#issuecomment-497641073
    // react hook formとreact-autosuggestのonBlurと合成
    // 両方にonBlurが登録されており
    // 合成しないとautosuggestのドロップダウンがエリア外がクリックされても閉じなくなる
    var onInputBlur = function onInputBlur(e) {
      if (inputProps.onBlur) {
        inputProps.onBlur(e);
      }

      if (registerProps.onBlur) {
        registerProps.onBlur(e);
      }

      if (onBlur) {
        onBlur();
      }
    };

    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .Fragment */ .HY, {
      children: [(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.createElement)("input", _objectSpread(_objectSpread(_objectSpread({}, inputProps), registerProps), {}, {
        onChange: onInputChange,
        onBlur: onInputBlur // spreadでkeyを渡すとwarningが発生するため直接指定する
        ,
        key: inputProps.key
      })), forceDisplayCloseButton || inputProps.value ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("button", {
        css: clearButtonStyle,
        onClick: onClearInput,
        type: "button",
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(main_javascripts_components_atoms_Icon__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .J, {
          styleKey: "close"
        })
      }) : ""]
    });
  };

  var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
    return value.trim().length > 0;
  };

  var shouldAlwaysRenderSuggestions = function shouldAlwaysRenderSuggestions() {
    return true;
  };

  var shouldRenderSuggestions = alwaysShowSuggestions ? shouldAlwaysRenderSuggestions : defaultShouldRenderSuggestions;
  var hasError = !!error;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    ref: inputBlockRef,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(main_javascripts_components_form_Label__WEBPACK_IMPORTED_MODULE_3__/* .Label */ ._, _objectSpread({}, label)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_emotion_react__WEBPACK_IMPORTED_MODULE_15__.ClassNames, {
      children: function children(_ref) {
        var css = _ref.css;
        var theme = {
          container: css(inputContainerStyle),
          suggestionsContainer: css(suggestionsContainerStyle),
          suggestionsContainerOpen: css(suggestionsContainerOpenStyle),
          suggestionsList: css(suggestionsListStyle),
          suggestion: css(suggestBlockStyle)
        };

        var InputProps = _objectSpread(_objectSpread({}, input), {}, {
          onChange: onInputChange,
          onFocus: onFocus,
          className: hasError ? css(inputWithErrorStyle, inputStyle, inputBorderColorStyle[borderColorStyleKey], inputFontSizeStyle[fontSizeStyleKey]) : css(inputStyle, inputBorderColorStyle[borderColorStyleKey], inputFontSizeStyle[fontSizeStyleKey]),
          autoComplete: "off",
          autoCorrect: "off"
        }); // TODO: InputErrorStyle


        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .Fragment */ .HY, {
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)((react_autosuggest__WEBPACK_IMPORTED_MODULE_2___default()), {
            suggestions: suggestions,
            onSuggestionsFetchRequested: onSuggestionsFetchRequested,
            onSuggestionsClearRequested: onSuggestionsClearRequested,
            getSuggestionValue: getSuggestionValue,
            inputProps: InputProps,
            theme: theme,
            renderSuggestion: renderSuggestion,
            onSuggestionSelected: onSuggestionSelected,
            focusInputOnSuggestionClick: false // suggestを選択したらblur
            ,
            renderInputComponent: renderInputComponent,
            shouldRenderSuggestions: shouldRenderSuggestions,
            ref: inputRef
          }), error && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(main_javascripts_components_form_InputError__WEBPACK_IMPORTED_MODULE_4__/* .InputError */ .p, {
            namespace: namespace,
            errorMessage: error.message,
            label: input.name
          })]
        });
      }
    })]
  });
};
var inputContainerStyle =  true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0;
var inputStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("padding-right:2rem;font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.form */ .JB.form, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontWeight.regular */ .Ue.regular, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";caret-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .accentColor.primaryColor */ .z.primaryColor, ";padding:0.125rem ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom1_5x */ .D.atom1_5x, " 0;box-sizing:border-box;margin:0;width:100%;height:40px;border:1px solid;border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_10__/* .borderRadius.normal */ .E.normal, ";appearance:none;&:focus{outline:none;border-bottom-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .accentColor.primaryColor */ .z.primaryColor, ";}&::placeholder{color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.disabledColor */ .zP.disabledColor, ";}" + ( true ? "" : 0),  true ? "" : 0);
var inputWithErrorStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("border-bottom-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .accentColor.alertColor */ .z.alertColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var suggestionsContainerStyle =  true ? {
  name: "wpmoml",
  styles: "display:none;box-sizing:border-box"
} : 0;
var suggestionsContainerOpenStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("display:block;position:absolute;top:37px;margin:0;max-height:600px;background-color:white;width:100%;z-index:100;box-shadow:0 6px 30px rgba(40, 40, 40, 0.1);border-top:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .accentColor.primaryColor */ .z.primaryColor, ";overflow:auto;pointer-events:none;" + ( true ? "" : 0),  true ? "" : 0);
var suggestionsListStyle =  true ? {
  name: "1lamgov",
  styles: "margin:0;padding:0;list-style-type:none;pointer-events:auto"
} : 0;
var suggestBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("border-bottom:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .borderColor.primaryLightColor */ .tv.primaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var suggestStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("position:relative;margin:0;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom2x */ .D.atom2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom */ .D.atom, " 3rem;cursor:pointer;color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";&:hover{background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .backgroundColor.secondaryLightColor */ .Cz.secondaryLightColor, ";}" + ( true ? "" : 0),  true ? "" : 0);
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("padding:calc(", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom */ .D.atom, " - (", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .lineHeight.body1 */ .Nv.body1, " - ", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.body */ .JB.body, ") / 2) ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0); // const inputErrorStyle = css`
//   padding: ${space.atom0_5x} 0 0;
// `;

var iconStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("position:absolute;top:0.4375rem;left:0.75rem;font-size:1.5rem;vertical-align:middle;color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";opacity:0.4;svg{width:100%;height:auto;path{fill:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";}}" + ( true ? "" : 0),  true ? "" : 0);
var suggestionValueBlockStyle =  true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0;
var suggestionValueStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("flex:1;width:60%;font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.body */ .JB.body, ";" + ( true ? "" : 0),  true ? "" : 0);
var suggestionLabelStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("display:block;width:40%;padding:0.2rem 0 0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_8__/* .space.atom */ .D.atom, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.caption */ .JB.caption, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.disabledColor */ .zP.disabledColor, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .lineHeight.caption3 */ .Nv.caption3, ";text-align:right;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var clearButtonStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("position:absolute;top:50%;right:0;font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.body */ .JB.body, ";background:none;border:0;transform:translateY(-50%);width:40px;height:40px;cursor:pointer;color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";outline:none;opacity:0.6;transition:opacity 0.4s ease;display:flex;align-items:center;justify-content:center;&:hover{opacity:1;}" + ( true ? "" : 0),  true ? "" : 0);
var inputBorderColorStyle = {
  none:  true ? {
    name: "1oscket",
    styles: "border-color:white"
  } : 0,
  primary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .borderColor.primaryDarkColor */ .tv.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0),
  secondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_7__/* .borderColor.secondaryLightColor */ .tv.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0)
};
var inputFontSizeStyle = {
  "default": /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.form */ .JB.form, ";" + ( true ? "" : 0),  true ? "" : 0),
  small: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_15__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_9__/* .fontSize.body */ .JB.body, ";" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 50169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ SvgIcon; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./main/javascripts/components/icon/svg/cruise.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }

var SvgCruise = function SvgCruise(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "m98.985 55.813-6.052-2.134V29.276a5.626 5.626 0 0 0-5.626-5.626H63.574v-7.97a3.516 3.516 0 1 0-7.032 0v7.97h-23.85a5.626 5.626 0 0 0-5.626 5.626v24.403l-6.052 2.134c-2.814 1.373-3.99 4.633-2.662 7.379l7.987 21.397c6.763-1.512 11.629-4.92 11.691-4.964l2.047-1.455 2.047 1.46c.073.052 8.09 5.669 17.873 5.669s17.8-5.617 17.88-5.674l2.047-1.455 2.047 1.46c.057.04 4.921 3.447 11.684 4.959l7.987-21.397c1.328-2.745.152-6.006-2.662-7.379ZM34.1 30.684h51.802v20.517l-23.237-8.192a6.1 6.1 0 0 0-5.328 0L34.1 51.201zM108.17 91.537c-2.49.734-5.322 1.263-8.321 1.263-9.783 0-17.8-5.617-17.873-5.669l-2.047-1.46-2.047 1.455c-.08.057-8.097 5.674-17.88 5.674s-17.8-5.617-17.873-5.669l-2.047-1.46-2.047 1.455c-.08.057-8.097 5.674-17.88 5.674-3 0-5.832-.529-8.321-1.263v7.28c2.554.611 5.358 1.014 8.321 1.014 8.945 0 16.454-3.661 19.924-5.687 3.47 2.026 10.979 5.687 19.924 5.687s16.454-3.661 19.924-5.687c3.47 2.026 10.979 5.687 19.924 5.687 2.964 0 5.768-.403 8.321-1.014v-7.281Z"
  })));
};
/* harmony default export */ var cruise = (SvgCruise);
;// CONCATENATED MODULE: ./main/javascripts/components/icon/svg/filter.svg
var filter_path, _path2;
var filter_excluded = ["title", "titleId"];
function filter_extends() { return filter_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, filter_extends.apply(null, arguments); }
function filter_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = filter_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function filter_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }

var SvgFilter = function SvgFilter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = filter_objectWithoutProperties(_ref, filter_excluded);
  return /*#__PURE__*/react.createElement("svg", filter_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, filter_path || (filter_path = /*#__PURE__*/react.createElement("path", {
    d: "M78.516 21.797v35.156h-7.031V21.797zM37.734 98.203V63.047h7.031v35.156zM12.188 35.859h52.266v7.031H12.188z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M71.484 35.859h36.328v7.031H71.484zM12.188 77.109h32.578v7.031H12.188zM51.797 77.109h56.016v7.031H51.797z"
  })));
};
/* harmony default export */ var filter = (SvgFilter);
;// CONCATENATED MODULE: ./main/javascripts/components/icon/svg/sort.svg
var sort_path, sort_path2, _path3;
var sort_excluded = ["title", "titleId"];
function sort_extends() { return sort_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, sort_extends.apply(null, arguments); }
function sort_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = sort_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function sort_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }

var SvgSort = function SvgSort(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = sort_objectWithoutProperties(_ref, sort_excluded);
  return /*#__PURE__*/react.createElement("svg", sort_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, sort_path || (sort_path = /*#__PURE__*/react.createElement("path", {
    d: "M32.109 23.438h7.031v71.719h-7.031z"
  })), sort_path2 || (sort_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M35.625 99.425 13.252 77.052l4.972-4.972 17.401 17.401L53.026 72.08l4.972 4.972zM87.891 96.562H80.86V24.843h7.031z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M101.776 47.92 84.375 30.519 66.974 47.92l-4.972-4.972 22.373-22.373 22.373 22.373z"
  })));
};
/* harmony default export */ var sort = (SvgSort);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/icon/SvgIcon.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var SvgIcon = function SvgIcon(props) {
  var name = props.name,
      _props$size = props.size,
      size = _props$size === void 0 ? "1.5rem" : _props$size,
      _props$color = props.color,
      color = _props$color === void 0 ? "#fff" : _props$color;
  var iconStyles = /*#__PURE__*/(0,emotion_react_browser_esm.css)(iconStyle, ";width:", size, ";path{fill:", color, ";}" + ( true ? "" : 0),  true ? "" : 0);
  var svgComponent = {
    cruise: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cruise, {}),
    filter: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(filter, {}),
    sort: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sort, {})
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: iconStyles,
    children: svgComponent[name]
  });
};
var iconStyle =  true ? {
  name: "pvk9mz",
  styles: "svg{display:block;width:100%;height:auto;}"
} : 0;

/***/ }),

/***/ 66356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RectSkeleton; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);


var _templateObject;




var RectSkeleton = function RectSkeleton() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
    css: blockStyle
  });
};
var shineKeyframes = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.keyframes)(_templateObject || (_templateObject = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  0% {\n    background-position: 0;\n  }\n  100% {\n    background-position: 800px;\n  }\n"]))); // 表示サイズは上位の要素で調整する

var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)("width:100%;height:100%;background-image:linear-gradient(\n    90deg,\n    #e1e1e1 0%,\n    #e1e1e1 30%,\n    #f5f5f5 50%,\n    #e1e1e1 70%,\n    #e1e1e1 100%\n  );animation-name:", shineKeyframes, ";animation-duration:2s;animation-delay:0.4s;animation-iteration-count:infinite;animation-timing-function:ease-out;background-size:800px;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 83827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ SuggestionFieldButton; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36716);
/* harmony import */ var _form_Label__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35183);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58589);
/* harmony import */ var _form_InputError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44464);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var SuggestionFieldButton = function SuggestionFieldButton(props) {
  var namespace = props.namespace,
      name = props.name,
      label = props.label,
      longName = props.longName,
      placeholder = props.placeholder,
      onClick = props.onClick,
      _props$borderColorSty = props.borderColorStyleKey,
      borderColorStyleKey = _props$borderColorSty === void 0 ? "none" : _props$borderColorSty,
      _props$fontSizeStyleK = props.fontSizeStyleKey,
      fontSizeStyleKey = _props$fontSizeStyleK === void 0 ? "default" : _props$fontSizeStyleK,
      error = props.error;
  var buttonStyles = longName ? buttonStyle : buttonPlaceholderStyle;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_form_Label__WEBPACK_IMPORTED_MODULE_5__/* .Label */ ._, _objectSpread({}, label)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("button", {
      type: "button",
      css: [buttonStyles, buttonBorderColorStyle[borderColorStyleKey], buttonFontSizeStyle[fontSizeStyleKey],  true ? "" : 0,  true ? "" : 0],
      onClick: onClick,
      children: longName || placeholder
    }), error && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_form_InputError__WEBPACK_IMPORTED_MODULE_7__/* .InputError */ .p, {
      namespace: namespace,
      errorMessage: error.message,
      label: name
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("padding:calc(", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom, " - (", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .lineHeight.body1 */ .Nv.body1, " - ", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.body */ .JB.body, ") / 2) ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var buttonStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.form */ .JB.form, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontWeight.regular */ .Ue.regular, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";caret-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.primaryColor */ .z.primaryColor, ";padding:0.125rem ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom1_5x */ .D.atom1_5x, " 0;box-sizing:border-box;margin:0;width:100%;height:40px;border:1px solid;border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_6__/* .borderRadius.normal */ .E.normal, ";background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .backgroundColor.primaryLightColor */ .Cz.primaryLightColor, ";text-align:left;appearance:none;&:focus{outline:none;}" + ( true ? "" : 0),  true ? "" : 0);
var buttonPlaceholderStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonStyle, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.disabledColor */ .zP.disabledColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var buttonBorderColorStyle = {
  none:  true ? {
    name: "1oscket",
    styles: "border-color:white"
  } : 0,
  primary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .borderColor.primaryDarkColor */ .tv.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0),
  secondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .borderColor.secondaryLightColor */ .tv.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0)
};
var buttonFontSizeStyle = {
  "default": /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.form */ .JB.form, ";" + ( true ? "" : 0),  true ? "" : 0),
  small: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.body */ .JB.body, ";" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 50193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ SuggestionPicker; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Icon/index.ts
var Icon = __webpack_require__(74303);
// EXTERNAL MODULE: ./main/javascripts/constants/DestinationTypes.ts
var DestinationTypes = __webpack_require__(25551);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/components/icon/SvgIcon.tsx + 3 modules
var SvgIcon = __webpack_require__(50169);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/suggestionPicker/SuggestionItem.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var SuggestionItem = function SuggestionItem(props) {
  var suggestion = props.suggestion,
      onSelected = props.onSelected,
      suggestIconType = props.suggestIconType;

  var onItemSelected = function onItemSelected() {
    onSelected(suggestion);
  };

  var iconType = "pin";
  var svgIconType;
  var isSvgIcon = false;
  var svgIconTypes = ["cruise"];

  if (suggestIconType) {
    if (svgIconTypes.includes(suggestIconType)) {
      svgIconType = suggestIconType;
      isSvgIcon = true;
    } else {
      iconType = suggestIconType;
    }
  } else {
    switch (suggestion.destinationType) {
      case DestinationTypes/* DestinationTypes.region */._.region:
        iconType = "city";
        break;

      case DestinationTypes/* DestinationTypes.hotel */._.hotel:
        iconType = "hotel";
        break;

      case DestinationTypes/* DestinationTypes.airport */._.airport:
        iconType = "airplane";
        break;

      default:
    }
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: suggestStyle,
    onClick: onItemSelected,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: iconStyle,
      children: isSvgIcon ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* SvgIcon */.l, {
        name: svgIconType
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
        styleKey: iconType
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: suggestionValueBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: suggestionValueStyle,
        children: suggestion.name
      }), suggestion.label && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: suggestionLabelStyle,
        children: suggestion.label
      })]
    })]
  });
};
var suggestStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;margin:0;padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom1_5x */.D.atom1_5x, " 4rem;cursor:pointer;color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";&:hover{background-color:#f5f5f5;}" + ( true ? "" : 0),  true ? "" : 0);
var iconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:0.625rem;left:1.5rem;font-size:1.5rem;display:flex;align-items:center;color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";opacity:0.3;svg{width:100%;height:auto;path{fill:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";}}" + ( true ? "" : 0),  true ? "" : 0);
var suggestionValueBlockStyle =  true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0;
var suggestionValueStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("flex:1;width:60%;font-size:", typographyStyle/* fontSize.body */.JB.body, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";" + ( true ? "" : 0),  true ? "" : 0);
var suggestionLabelStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:block;width:40%;padding:0.2rem 0 0 ", spaceStyle/* space.atom */.D.atom, ";font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";color:", colorStyle/* textColor.disabledColor */.zP.disabledColor, ";line-height:", typographyStyle/* lineHeight.caption3 */.Nv.caption3, ";text-align:right;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/skeleton/RectSkeleton.tsx
var RectSkeleton = __webpack_require__(66356);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
;// CONCATENATED MODULE: ./main/javascripts/components/suggestionPicker/SuggestionItemSkeleton.tsx








var SuggestionItemSkeleton = function SuggestionItemSkeleton() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: SuggestionItemSkeleton_suggestStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: SuggestionItemSkeleton_iconStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RectSkeleton/* RectSkeleton */.I, {})
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: SuggestionItemSkeleton_suggestionValueBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: suggestionSkeletonStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RectSkeleton/* RectSkeleton */.I, {})
      })
    })]
  });
};
var SuggestionItemSkeleton_suggestStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;margin:0;padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";" + ( true ? "" : 0),  true ? "" : 0);
var SuggestionItemSkeleton_iconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:", typographyStyle/* fontSize.headline */.JB.headline, ";height:", typographyStyle/* fontSize.headline */.JB.headline, ";margin:0 1.25rem 0 ", spaceStyle/* space.atom */.D.atom, ";border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";overflow:hidden;" + ( true ? "" : 0),  true ? "" : 0);
var SuggestionItemSkeleton_suggestionValueBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;align-items:center;width:50%;height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";" + ( true ? "" : 0),  true ? "" : 0);
var suggestionSkeletonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;height:", typographyStyle/* fontSize.body */.JB.body, ";border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";overflow:hidden;" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/suggestionPicker/SuggestionPicker.tsx


var _excluded = ["onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function SuggestionPicker_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














// 現在モバイル専用
var SuggestionPicker = function SuggestionPicker(props) {
  var name = props.name,
      suggestions = props.suggestions,
      placeholder = props.placeholder,
      isLoading = props.isLoading,
      onRequest = props.onRequest,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onSelected = props.onSelected,
      onClear = props.onClear,
      suggestOptions = props.suggestOptions,
      suggestIconType = props.suggestIconType;

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      setValue = _useFormContext.setValue,
      control = _useFormContext.control;

  var _register = register(name),
      onChange = _register.onChange,
      registerProps = (0,objectWithoutProperties/* default */.Z)(_register, _excluded);

  var currentValue = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: name
  });
  var suggestionBlockRef = (0,react.useRef)();
  (0,react.useEffect)(function () {
    if (visualViewport) {
      visualViewport.addEventListener("resize", onResizeWindow);
    }

    return function () {
      if (visualViewport) {
        visualViewport.removeEventListener("resize", onResizeWindow);
      }
    };
  }, []);

  var onResizeWindow = function onResizeWindow() {
    if (suggestionBlockRef.current && visualViewport) {
      suggestionBlockRef.current.style.height = "calc(".concat(window.visualViewport.height, "px - 7rem - ").concat(spaceStyle/* space.atom */.D.atom, ")");
    }
  };

  var onDestinationChange = function onDestinationChange(event) {
    var value = event.target.value;

    if (value) {
      onRequest(_objectSpread({
        text: value
      }, suggestOptions || {}));
    }

    if (!value && onClear) {
      onClear();
    }
  };

  var onSuggestionSelected = function onSuggestionSelected(suggestion) {
    onSelected(suggestion);
  };

  var onClearInput = function onClearInput(event) {
    event.preventDefault();
    setValue(name, "");

    if (onClear) {
      onClear();
    }
  }; // react hook formのonChangeと合成


  var onInputChange = function onInputChange(e) {
    void onChange(e);
    onDestinationChange(e);
  };

  var onInputBlur = function onInputBlur(e) {
    if (registerProps.onBlur) {
      registerProps.onBlur(e);
    }

    if (onBlur) {
      onBlur();
    }
  };

  var renderItems = function renderItems() {
    if (isLoading) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionItemSkeleton, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionItemSkeleton, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionItemSkeleton, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionItemSkeleton, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionItemSkeleton, {})]
      });
    } else {
      return suggestions.map(function (suggestion) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionItem, {
          suggestion: suggestion,
          onSelected: onSuggestionSelected,
          suggestIconType: suggestIconType
        }, suggestion.id);
      });
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: inputBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", _objectSpread(_objectSpread({
        css: inputStyle,
        name: name,
        placeholder: placeholder
      }, registerProps), {}, {
        onChange: onInputChange,
        onBlur: onInputBlur,
        onFocus: onFocus
      })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: searchIconStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
          styleKey: "search"
        })
      }), currentValue ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
        css: clearButtonStyle,
        onClick: onClearInput,
        type: "button",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: clearButtonIconStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
            styleKey: "close"
          })
        })
      }) : ""]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: suggestionBlockStyle,
      ref: suggestionBlockRef,
      children: renderItems()
    })]
  });
};
var inputBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;padding:", spaceStyle/* space.atom2x */.D.atom2x, ";border-bottom:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var inputStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.form */.JB.form, ";font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";padding:0 2.5rem 0 2.5rem;box-sizing:border-box;margin:0;width:100%;height:3rem;border:0;appearance:none;background-color:", colorStyle/* backgroundColor.ground */.Cz.ground, ";border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";&:focus{outline:none;}&::placeholder{color:", colorStyle/* textColor.disabledColor */.zP.disabledColor, ";}" + ( true ? "" : 0),  true ? "" : 0); // const inputWithErrorStyle = css`
//   border-bottom-color: ${accentColor.alertColor};
// `;

var blockStyle =  true ? {
  name: "1wv4onu",
  styles: "position:relative;height:100%"
} : 0;
var clearButtonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:50%;right:", spaceStyle/* space.atom2x */.D.atom2x, ";background:none;border:0;transform:translateY(-50%);width:40px;height:40px;cursor:pointer;outline:none;opacity:0.6;transition:opacity 0.4s ease;display:flex;align-items:center;justify-content:center;&:hover{opacity:1;}&:before{content:\"\";position:absolute;display:block;width:1.25rem;height:1.25rem;background-color:", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";border-radius:50%;}" + ( true ? "" : 0),  true ? "" : 0);
var clearButtonIconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;align-items:center;position:relative;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var searchIconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;align-items:center;position:absolute;top:50%;left:1.875rem;font-size:", typographyStyle/* fontSize.body */.JB.body, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";transform:translateY(-50%);" + ( true ? "" : 0),  true ? "" : 0);
var suggestionBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("height:calc(100% - 3rem - ", spaceStyle/* space.atom */.D.atom, ");overflow:auto;padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 25551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ DestinationTypes; }
/* harmony export */ });
var DestinationTypes = {
  region: "region",
  hotel: "hotel",
  airport: "airport"
};

/***/ })

}]);